"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../../baseSchema");
const baseClickSchema_1 = require("../../baseSchema/baseClickSchema");
class ClickMigrationNewClub extends baseClickSchema_1.BaseClickSchema {
    constructor({ componentName, productId }) {
        super({ componentName });
        this.action = baseSchema_1.ActionsName.CLICK_MIGRATE_NEW_CLUB;
        this.productId = productId;
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            productId: this.productId,
            action: this.action
        };
    }
}
exports.default = ClickMigrationNewClub;
